import type { Subscription } from '../types';

export type OwnerSubscriptionType = Subscription['subscriptionType'];

/** True when the platform subscription includes academy owner entitlements. */
export function subscriptionTypeIncludesAcademy(
  subscriptionType: OwnerSubscriptionType | undefined | null
): boolean {
  return subscriptionType === 'academy_owner' || subscriptionType === 'combined';
}

/** True when the platform subscription includes club owner entitlements. */
export function subscriptionTypeIncludesClub(
  subscriptionType: OwnerSubscriptionType | undefined | null
): boolean {
  return subscriptionType === 'club_owner' || subscriptionType === 'combined';
}

/** Matches public directory SQL: active, trialing, or past_due platform subscriptions. */
export function isPublicDirectorySubscriptionEligible(
  status: Subscription['status'] | undefined | null
): boolean {
  return status === 'active' || status === 'trialing' || status === 'past_due';
}
